<template>

  <div>
    <financial-institution-list-add-new
      :is-add-new-financial-institution-sidebar-active.sync="isAddNewFinancialInstitutionSidebarActive"
      :financial-institution-id="currentyFinancialInstitutionId"
      @refetch-data="refetchData"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row align-h="between">
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-start  mb-1 mb-md-0"
          >
            <v-select
              id="status-id"
              v-model="showActiveOnly"
              class="w-75 mr-1"
              name="status-id"
              :options="activeOptions"
              label="label"
              item-value="value"
              item-text="label"
              placeholder="Status"
              :clearable="false"
            />
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
                debounce="500"
              />
              <b-button
                variant="primary"
                @click="addFinancialInstitution()"
              >
                <span class="text-nowrap">
                  Novo banco
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refFinancialInstitutionListTable"
        class="position-relative"
        :items="fetchFinancialInstitutions"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: dutyType -->
        <template #cell(dutyType)="data">
          <b-media vertical-align="center">
            {{ data.item.type }}
          </b-media>
        </template>

        <template #cell(active)="data">
          <b-badge
            pill
            :variant="`light-${resolveFinancialInstitutionStatusVariant(data.item.active)}`"
            class="text-capitalize"
          >
            {{ data.item.active ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              @click="editFinancialInstitution(data.item)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalFinancialInstitutions"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia,
  BBadge, BPagination, BButton, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import useFinancialInstitutionList from './useFinancialInstitutionList'
import financialInstitutionStoreModule from '../financialInstitutionStoreModule'
import FinancialInstitutionListAddNew from './FinancialInstitutionsAddNew.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,
    vSelect,
    FinancialInstitutionListAddNew,
  },
  directives: {
    Ripple,
  },
  setup() {
    const FINANCIAL_INSTITUTION_APP_STORE_MODULE_NAME = 'app-financial-institution'

    // Register module
    if (!store.hasModule(FINANCIAL_INSTITUTION_APP_STORE_MODULE_NAME)) store.registerModule(FINANCIAL_INSTITUTION_APP_STORE_MODULE_NAME, financialInstitutionStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(FINANCIAL_INSTITUTION_APP_STORE_MODULE_NAME)) store.unregisterModule(FINANCIAL_INSTITUTION_APP_STORE_MODULE_NAME)
    })

    const isAddNewFinancialInstitutionSidebarActive = ref(false)
    const currentyFinancialInstitutionId = ref(null)

    const statusOptions = [
      { label: 'Ativo', value: true },
      { label: 'Inativo', value: false },
    ]

    function addFinancialInstitution() {
      currentyFinancialInstitutionId.value = undefined
      isAddNewFinancialInstitutionSidebarActive.value = true
    }

    function editFinancialInstitution(dutyType) {
      currentyFinancialInstitutionId.value = dutyType.id
      isAddNewFinancialInstitutionSidebarActive.value = true
    }

    const {
      fetchFinancialInstitutions,
      tableColumns,
      perPage,
      currentPage,
      totalFinancialInstitutions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refFinancialInstitutionListTable,
      refetchData,

      // UI
      resolveFinancialInstitutionStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
      activeOptions,
      showActiveOnly,
    } = useFinancialInstitutionList()

    return {
      isAddNewFinancialInstitutionSidebarActive,
      fetchFinancialInstitutions,
      tableColumns,
      perPage,
      currentPage,
      totalFinancialInstitutions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refFinancialInstitutionListTable,
      refetchData,
      addFinancialInstitution,
      editFinancialInstitution,
      // Filter
      avatarText,
      // UI
      resolveFinancialInstitutionStatusVariant,
      currentyFinancialInstitutionId,
      statusOptions,
      // Extra Filters
      roleFilter,
      planFilter,
      situationFilter,
      statusFilter,
      activeOptions,
      showActiveOnly,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
